import { Fragment, useEffect, useRef, useState } from "react";
import { getServiceCountByStatus } from "../store/api/Services";
import { Button, Card, Col, Form, Row, Table } from "react-bootstrap";
import DatePicker from "react-datepicker2";
import { BarChartFill, List, Printer } from "react-bootstrap-icons";
import ModalSelectStaff from "../../Components/Modals/ModalSelectStaff";
import { keyIsLetterOrNumber } from "../../store/api/CommonFunctions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartArea } from "@fortawesome/free-solid-svg-icons";
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, XAxis, YAxis } from "recharts";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const ServiceCountByStatusReport = () => {
    const history = useHistory();
    const filterData = useRef();
    const [dateFilters, setDateFilters] = useState({});
    const [dataList, setDataList] = useState(null);
    const [popStaff, setPopStaff] = useState({ show: false });
    const [selectedStaff, setSelectedStaff] = useState(null);
    const statusList = dataList?.Data ? [...new Set(dataList.Data.map(d => d.Status))] : [];
    const installCount = dataList?.Data?.map(i => i.InstallCount).reduce((a, b) => a + b, 0);
    const repairCount = dataList?.Data?.map(i => i.RepairCount).reduce((a, b) => a + b, 0);
    const renderLegend = (props) => {
        const { payload } = props;
        return (
            <Fragment>
                {
                    payload.map((entry, index) => (
                        <span key={`item-${index}`} style={{ color: `${entry.color}`, fontSize: "11px" }}>
                            <div style={{ backgroundColor: `${entry.color}`, width: "10px", height: "10px", display: "inline-block" }}></div>
                            &nbsp;{entry.value.replace("InstallCount", "نصب ها").replace("RepairCount", "تعمیرها").replace("Count", "تعداد")}
                        </span>
                    ))
                }
            </Fragment>
        );
    }
    function search() {
        const data = {};
        const dateFrom = document.getElementsByName("ContactDateFrom")[0].value;
        if (dateFrom !== "") {
            data.ContactDateFrom = dateFilters.ContactDateFrom;
            data.PContactDateFrom = dateFrom;
        }
        const dateTo = document.getElementsByName("ContactDateTo")[0].value;
        if (dateTo !== "") {
            data.ContactDateTo = dateFilters.ContactDateTo;
            data.PContactDateTo = dateTo;
        }
        const refDateFrom = document.getElementsByName("LastRefDateFrom")[0].value;
        if (refDateFrom !== "") {
            data.LastRefDateFrom = dateFilters.LastRefDateFrom;
            data.PLastRefDateFrom = refDateFrom;
        }
        const refDateTo = document.getElementsByName("LastRefDateTo")[0].value;
        if (refDateTo !== "") {
            data.LastRefDateTo = dateFilters.LastRefDateTo;
            data.PLastRefDateTo = refDateTo;
        }
        const sendDateFrom = document.getElementsByName("StaffSendDateFrom")[0].value;
        if (sendDateFrom !== "") {
            data.StaffSendDateFrom = dateFilters.StaffSendDateFrom;
            data.PStaffSendDateFrom = sendDateFrom;
        }
        const sendDateTo = document.getElementsByName("StaffSendDateTo")[0].value;
        if (sendDateTo !== "") {
            data.StaffSendDateTo = dateFilters.StaffSendDateTo;
            data.PStaffSendDateTo = sendDateTo;
        }
        const archiveDateFrom = document.getElementsByName("ArchiveDateFrom")[0].value;
        if (archiveDateFrom !== "") {
            data.ArchiveDateFrom = dateFilters.ArchiveDateFrom;
            data.PArchiveDateFrom = archiveDateFrom;
        }
        const archiveDateTo = document.getElementsByName("ArchiveDateTo")[0].value;
        if (archiveDateTo !== "") {
            data.ArchiveDateTo = dateFilters.ArchiveDateTo;
            data.PArchiveDateTo = archiveDateTo;
        }
        data.StaffID = selectedStaff?.ID;
        filterData.current = data;
        getServiceCountByStatus(data, setDataList);

    }
    function showModalStaff(e) {
        if (e.key && !keyIsLetterOrNumber(e.keyCode, e.key)) {
            return;
        }
        setPopStaff({
            show: true,
            value: e?.target?.key ?? "",
            onSelect: setSelectedStaff
        })
    }
    function print(e) {
        history.push({
            pathname: `/PrintViewer/ServiceCountByStatus/${e.ctrlKey ?? false}`,
            state: {
                jsonObject: dataList?.Data,
                fetchBody: JSON.stringify(filterData.current ?? {})
            }
        });

    }
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-خدمات";

    })
    return (
        <div className="container-fluid mt-2">
            <br />
            <ModalSelectStaff popData={popStaff} setPopSelectStaff={setPopStaff} />
            <Card style={{ textAlign: "right" }}>
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faChartArea} size="lg" />&nbsp;
                    گزارش تعدادی وضعیت سرویس ها
                </Card.Header>
                <Card.Body className="bodyStyle">
                    <Row className="rowBorder">
                        <Col md={2} className="form-group">
                            <label>تاریخ پذیرش از: </label>
                            <DatePicker className="form-control" timePicker={false} isGregorian={false} name="ContactDateFrom" onChange={val => dateFilters.ContactDateFrom = val.local("en").format("YYYY-MM-DD")} />
                        </Col>
                        <Col md={2} className="form-group">
                            <label>تاریخ پذیرش تا: </label>
                            <DatePicker className="form-control" timePicker={false} isGregorian={false} name="ContactDateTo" onChange={val => dateFilters.ContactDateTo = val.local("en").format("YYYY-MM-DD")} />
                        </Col>
                        <Col md={2} className="form-group">
                            <label>تاریخ انجام از: </label>
                            <DatePicker className="form-control" timePicker={false} isGregorian={false} name="LastRefDateFrom" onChange={val => dateFilters.LastRefDateFrom = val.local("en").format("YYYY-MM-DD")} />
                        </Col>
                        <Col md={2} className="form-group">
                            <label>تاریخ انجام تا: </label>
                            <DatePicker className="form-control" timePicker={false} isGregorian={false} name="LastRefDateTo" onChange={val => dateFilters.LastRefDateTo = val.local("en").format("YYYY-MM-DD")} />
                        </Col>
                        <Col md={2} className="form-group">
                            <label>تاریخ اعزام از: </label>
                            <DatePicker className="form-control" timePicker={false} isGregorian={false} name="StaffSendDateFrom" onChange={val => dateFilters.StaffSendDateFrom = val.local("en").format("YYYY-MM-DD")} />
                        </Col>
                        <Col md={2} className="form-group">
                            <label>تاریخ اعزام تا: </label>
                            <DatePicker className="form-control" timePicker={false} isGregorian={false} name="StaffSendDateTo" onChange={val => dateFilters.StaffSendDateTo = val.local("en").format("YYYY-MM-DD")} />
                        </Col>
                        <Col md={2} className="form-group">
                            <label>تاریخ بایگانی از: </label>
                            <DatePicker className="form-control" timePicker={false} isGregorian={false} name="ArchiveDateFrom"
                                onChange={val => dateFilters.ArchiveDateFrom = val.local("en").format("YYYY-MM-DD")} />
                        </Col>
                        <Col md={2} className="form-group">
                            <label>تاریخ بایگانی تا: </label>
                            <DatePicker className="form-control" timePicker={false} isGregorian={false} name="ArchiveDateTo"
                                onChange={val => dateFilters.ArchiveDateTo = val.local("en").format("YYYY-MM-DD")} />
                        </Col>
                        <Col md={2} className="form-group">
                            <label className="ellipsisLabel"> تکنسین انجام دهنده کار: </label>
                            <Form.Control name="StaffName" readOnly value={selectedStaff?.LastName ?? ""} onKeyDown={showModalStaff} />
                            <Button className="btn-input-tiny" onClick={showModalStaff}><List size={23} /></Button>
                        </Col>
                    </Row>
                    <Button className="group-Btn-large mt-1" onClick={search}>
                        <BarChartFill size={18} />&nbsp; خروجی گزارش
                    </Button>
                    <Button variant="secondary" className="group-Btn-large mt-1" onClick={print} disabled={!dataList?.Data}>
                        <Printer size={18} />&nbsp; چاپ گزارش
                    </Button>
                    <Row style={{ margin: 0 }}>
                        <Col md={6} style={{ overflow: "auto", padding: 0 }} className="scThin">
                            <Table className="mt-1 mb-0" style={{ whiteSpace: "nowrap" }}>
                                <thead >
                                    <th style={{ padding: "5px" }}>نوع سرویس</th>
                                    <th style={{ padding: "5px" }}>تعداد کل</th>
                                    {statusList &&
                                        statusList.map((item, i) => <th key={i} style={{ padding: "5px" }}>{item}</th>)
                                    }
                                </thead>
                                <tbody>
                                    <tr className="resultTableRow">
                                        <td>نصب</td>
                                        <td>{installCount}</td>
                                        {dataList?.Data?.map((item, i) => <td key={i}>{item.InstallCount}</td>)}
                                    </tr>
                                    <tr className="resultTableRow">
                                        <td>تعمیر</td>
                                        <td>{repairCount}</td>
                                        {dataList?.Data?.map((item, i) => <td key={i}>{item.RepairCount}</td>)}
                                    </tr>
                                </tbody>
                            </Table>
                        </Col>
                        <Col md={6} style={{ textAlign: "center" }}>
                            {dataList?.Data &&
                                <ResponsiveContainer width="100%" height="100%" className="barChart" debounce={300}>
                                    <BarChart data={dataList.Data}>
                                        <Legend align="left" content={renderLegend} verticalAlign="bottom" />
                                        <XAxis dataKey="Status" style={{ fontSize: "8px" }} reversed={true} minTickGap={1} width={100} />
                                        <YAxis dx={15} style={{ fontSize: "10px" }} orientation="right" padding={{ top: 15 }} tickMargin={5} />
                                        <CartesianGrid />
                                        <Bar dataKey="InstallCount" fill="#05386b" label={{ position: 'top' }} isAnimationActive={false} />
                                        <Bar dataKey="RepairCount" fill="#e54809" label={{ position: 'top' }} isAnimationActive={false} />
                                    </BarChart>
                                </ResponsiveContainer>
                            }
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </div>
    )
}
export default ServiceCountByStatusReport;